// Create: src/pages/admin/dashboard/components/StatCard.jsx
import React from 'react';

const StatCard = ({ title, value, icon, change, changeType, subtitle, color = 'emerald', extra }) => {
  const colorClasses = {
    emerald: {
      bg: 'from-emerald-500 to-emerald-600',
      iconBg: 'bg-emerald-100',
      iconColor: 'text-emerald-600',
      changeBg: changeType === 'increase' ? 'bg-emerald-50' : 'bg-red-50',
      changeText: changeType === 'increase' ? 'text-emerald-700' : 'text-red-700'
    },
    blue: {
      bg: 'from-blue-500 to-blue-600',
      iconBg: 'bg-blue-100',
      iconColor: 'text-blue-600',
      changeBg: changeType === 'increase' ? 'bg-blue-50' : 'bg-red-50',
      changeText: changeType === 'increase' ? 'text-blue-700' : 'text-red-700'
    },
    purple: {
      bg: 'from-purple-500 to-purple-600',
      iconBg: 'bg-purple-100',
      iconColor: 'text-purple-600',
      changeBg: changeType === 'increase' ? 'bg-purple-50' : 'bg-red-50',
      changeText: changeType === 'increase' ? 'text-purple-700' : 'text-red-700'
    },
    amber: {
      bg: 'from-amber-500 to-amber-600',
      iconBg: 'bg-amber-100',
      iconColor: 'text-amber-600',
      changeBg: changeType === 'increase' ? 'bg-amber-50' : 'bg-red-50',
      changeText: changeType === 'increase' ? 'text-amber-700' : 'text-red-700'
    }
  };

  const classes = colorClasses[color];

  const formatValue = (val) => {
    if (typeof val === 'number') {
      return val.toLocaleString(); // ✅ Always show full amount with thousands separator
    }
    return val;
  };

  return (
    <div className="relative group">
      {/* Glow effect */}
      <div className="absolute -inset-0.5 bg-gradient-to-r opacity-20 group-hover:opacity-40 transition-opacity duration-500 blur rounded-xl" 
           style={{background: `linear-gradient(45deg, ${color === 'emerald' ? '#10b981, #059669' : color === 'blue' ? '#3b82f6, #2563eb' : color === 'purple' ? '#8b5cf6, #7c3aed' : '#f59e0b, #d97706'})`}}></div>
      
      <div className="relative bg-white rounded-xl shadow-xl border border-gray-100 p-6 hover:shadow-2xl transition-all duration-300 group-hover:-translate-y-1">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <div className={`p-3 rounded-lg ${classes.iconBg} group-hover:scale-110 transition-transform duration-300`}>
            <div className={`h-6 w-6 ${classes.iconColor}`}>
              {icon}
            </div>
          </div>
          {change && (
            <div className={`px-2 py-1 rounded-full ${classes.changeBg} flex items-center space-x-1`}>
              <svg 
                className={`h-3 w-3 ${classes.changeText}`} 
                fill="currentColor" 
                viewBox="0 0 20 20"
              >
                {changeType === 'increase' ? (
                  <path fillRule="evenodd" d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z" clipRule="evenodd" />
                ) : (
                  <path fillRule="evenodd" d="M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z" clipRule="evenodd" />
                )}
              </svg>
              <span className={`text-xs font-medium ${classes.changeText}`}>{change}</span>
            </div>
          )}
        </div>

        {/* Content */}
        <div className="space-y-2">
          <h3 className="text-sm font-medium text-gray-600">{title}</h3>
          <div className="flex items-baseline space-x-2">
            <span className="text-3xl font-bold text-gray-900">{formatValue(value)}</span>
            {subtitle && <span className="text-sm text-gray-500">{subtitle}</span>}
          </div>
          {extra && <div className="pt-1">{extra}</div>}
        </div>

        {/* Gradient line */}
        <div className={`absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r ${classes.bg} rounded-b-xl`}></div>
      </div>
    </div>
  );
};

export default StatCard;